import { render } from "./EmployeeApprovePayment.vue?vue&type=template&id=06781244"
import script from "./EmployeeApprovePayment.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovePayment.vue?vue&type=script&lang=js"

import "./EmployeeApprovePayment.vue?vue&type=style&index=0&id=06781244&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__